import gql from 'graphql-tag';

export const ArchiveLongTaskStatusExperimental =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query ArchiveLongTaskStatusExperimental($taskId: ID!) @experimental {
			experimentalLongTask(taskId: $taskId) {
				id
				elapsedTime
				percentageComplete
				messages {
					translation
				}
				successful
			}
		}
	`;
